<div class="confirm-modal-popup">
  <span class="material-icons close-icon-modal position-absolute" (click)="onCancel()">close</span>
  <img src="assets/images/check-icon.svg" alt="check-icon" class="modal-icon">
  <h2 *ngIf="data.title && data.title !== 'Confirm' && data.title !== 'Confirmation'" class="modal-title">{{ data.title }}</h2>
  <div class="modal-message">
    <p class="f-16 pb-0 mb-0">{{ data.message }}</p>
  </div>
  <div class="modal-actions">
    <button (click)="onConfirm()" mat-button class="btn rounded_btn green_btn small_btn px-4 fw-400">{{ data.confirmText || 'Yes' }}</button>
    <button (click)="onCancel()" mat-button class="btn rounded_btn cancel_btn small_btn px-4 fw-400">{{ data.cancelText || 'No' }}</button>
  </div>
</div>
